import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';

export interface ViaCepResponse {
  cep?: string;
  logradouro?: string;
  complemento?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  ibge?: string;
  gia?: string;
  ddd?: string;
  siafi?: string;
  erro?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CepRepository {
  private readonly apiPath: string = 'https://viacep.com.br/ws';

  constructor(private http: HttpClient) {}

  buscarPorCep(cep: string): Observable<ViaCepResponse | null> {
    const cleanCep = (cep || '').replace(/\D/g, '');
    if (cleanCep.length !== 8) {
      return of(null);
    }
    return this.http.get<ViaCepResponse>(`${this.apiPath}/${cleanCep}/json/`).pipe(
      catchError(() => of(null))
    );
  }

  buscarCep(cep: string): Observable<ViaCepResponse | null> {
    return this.buscarPorCep(cep);
  }

  buscarEndereco(uf: string, cidade: string, endereco: string): Observable<ViaCepResponse[] | null> {
    if (!uf || !cidade || !endereco) return of(null);
    const url = `${this.apiPath}/${uf.toLowerCase()}/${cidade.toLowerCase()}/${endereco.toLowerCase()}/json/`;
    return this.http.get<ViaCepResponse[]>(url).pipe(
      catchError(() => of(null))
    );
  }
}
